import { CookieNotice } from '@pixelart/jquery-cookie-consent';

import './cookienotice.scss';

export function cookieNotice() {
    $('.px-cookie-consent-notification').each((idx, element) => {
        const notice = new CookieNotice(element, {});
        notice.showCookieBanner();
    });
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./assets/components/cookienotice/cookienotice.ts